import { ChevronUp, ChevronDown } from "lucide-react";
import { Button } from "@/v2/components/ui/button";
import { Input } from "@/v2/components/ui/input";
import { cn } from "@/v2/lib/utils";

interface NumberStepperProps {
	value: number;
	onChange: (value: number) => void;
	min?: number;
	step?: number;
	className?: string;
}

export function NumberStepper({
	value,
	onChange,
	min = 0,
	step = 1,
	className,
}: NumberStepperProps) {
	return (
		<div className={cn("flex gap-1", className)}>
			<Input
				type="text"
				inputMode="numeric"
				className="w-16 text-right text-sm"
				value={value}
				onChange={(e) => {
					const parsed = Number(e.target.value);
					if (!isNaN(parsed)) onChange(Math.max(min, parsed));
				}}
			/>
			<div className="flex flex-col gap-0.5">
				<Button
					type="button"
					variant="outline"
					size="icon"
					onClick={() => onChange(Math.round((value + step) * 100) / 100)}
					className="h-[18px] w-7 p-0"
					tabIndex={-1}
				>
					<ChevronUp className="h-3 w-3" />
				</Button>
				<Button
					type="button"
					variant="outline"
					size="icon"
					onClick={() => onChange(Math.max(min, Math.round((value - step) * 100) / 100))}
					className="h-[18px] w-7 p-0"
					tabIndex={-1}
				>
					<ChevronDown className="h-3 w-3" />
				</Button>
			</div>
		</div>
	);
}
